<template>
  <div>
    <div class="time-picker">
      <el-date-picker
        v-model="duration"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        @change="durationChange"
        :clearable="isClear">
      </el-date-picker>
      <el-select v-model="hospitalDaily" placeholder="请选择医院"
                 filterable
                 remote
                 :remote-method="remoteMethod"
                 :loading="hospitalLoading"
                 @change="changeHospital">
        <el-option
          v-for="item in hospitalFilterList"
          :key="item.hospitalId"
          :label="item.hospitalName"
          :value="item.hospitalId">
        </el-option>
      </el-select>
      <el-select v-model="projectType" placeholder="请选择部位"
                 @change="changeHospital">
        <el-option
          v-for="item in presetList"
          :key="item.preset_id"
          :label="item.preset_name"
          :value="item.preset_id">
        </el-option>
      </el-select>
      <el-select v-model="value" placeholder="请选择文件类型"
                 @change="changeFileType">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" @click="downloadSelectFile">下载选中文件</el-button>
      <el-button @click="toggleSelection()">取消选择</el-button>
      <el-button type="success" @click="exportExcel">导出表格</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="order_sn"
        label="订单号"
        width="120">
      </el-table-column>
      <el-table-column
        label="创建日期"
        width="200">
        <template slot-scope="scope">{{ parseTime(scope.row.create_date) }}</template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名字"
        width="120">
      </el-table-column>
    </el-table>
    <div class="selected-count">
      已选择 {{ multipleSelection.length }} 个订单号
    </div>
<!--    <el-pagination-->
<!--      background-->
<!--      layout="prev, pager, next, total"-->
<!--      :total="total"-->
<!--      :page-size="pageSize"-->
<!--      @current-change="changePage">-->
<!--    </el-pagination>-->
  </div>
</template>

<script>
  import Global from "./Global";
  import JsUtill from "../util/JsUtill";

  export default {
    name: 'datadownload',
    mounted() {
      this.initData() ,
      this.getHospitalList(),
      this.getPresetList()
    },
    data: function () {
      return {
        // 时间选择器
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        duration: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)],
        isClear: false,
        // 文件类型
        options: [{
          value: 'txt',
          label: 'txt'
        }, {
          value: 'jpg',
          label: 'jpg'
        }, {
          value: 'zip',
          label: 'zip'
        },
        {
          value: 'mp4',
          label: 'mp4'
        }, 
        {
          value: '_3d.zip',
          label: '3dZip'
        }, 
        {
          value: 'tdestimate',
          label: 'tdestimate'
        }],
        value: 'zip',
        // 列表
        tableData: [],
        multipleSelection: [],
        // 分页
        total: 0,
        pageSize: 100000,
        pageNum: 1,
        hospitalList: [],
        hospitalFilterList: [],
        presetList:[],
        hospital: '',
        hospitalDaily: '',
        projectType:'',
        hospitalLoading: false
      }
    },
    computed: {
      parseTime() {
        return function (time) {
          return JsUtill.methods.getTime(time)
        }
      }
    },
    methods: {
      getHospitalList() {
        let that = this
        this.axios({
          method: 'GET',
          url: Global.yunyingUrl + '/service-hospital/hospital/getAllHospital'
        }).then(resp => {
          let data = resp.data
          if (data.code === 1000) {
            that.hospitalList = data.data
            that.hospitalFilterList = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      remoteMethod(query) {
        if (query !== '') {
          this.hospitalLoading = true;
          setTimeout(() => {
            this.hospitalLoading = false;
            this.hospitalFilterList = this.hospitalList.filter(item => {
              return item.hospitalName.toLowerCase()
                .includes(query.toLowerCase());
            });
          }, 200);
        } else {
          this.hospitalFilterList = this.hospitalList;
        }
      },
      getPresetList() {
        let that = this
        this.axios({
          method: 'GET',
          url: Global.yunyingUrl + '/system/order/getAllPreset'
        }).then(resp => {
          let data = resp.data
          if (data.code === 1000) {
            that.presetList = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      // 初始化数据
      async initData() {
        let pageSize = this.pageSize
        let pageNum = this.pageNum
        let fileType = this.value
        let durationStart = this.duration[0].getTime()
        let durationEnd = this.duration[1].getTime()
        let resp = await this.axios(
          {
            method: 'get',
            url: Global.yunyingUrl + '/service-order/order/getPlaqueData?durationStart=' + durationStart +
              '&durationEnd=' + durationEnd + '&pageNum=' + pageNum + '&pageSize=' + pageSize+ '&hospitalId=' + this.hospitalDaily+'&presetId='+ this.projectType ,
            data: {
              "userType": 0,
              "orderType": 0,
              "name": '',
              "durationStart": durationStart,
              "durationEnd": durationEnd,
              "phoneNumber": '',
              "pageNum": pageNum,
              "pageSize": pageSize,
              "account": ''
            }
          }
        )
        if (resp.data.code === 1000) {
          let data = resp.data.data 
          // 遍历数组，将不包含所需类型文件的订单去掉
          for (let i = 0; i < data.length; i++) {
            // 如果 url 中不包含当前选中类型的文件，从数组中移除
            if (data[i].image_url.indexOf(fileType) === -1) {
              data.splice(i, 1)
              i--
            }
          }
          this.tableData = data
        } else {
          this.$message.error('请求数据失败')
        }
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 分页改变
      changePage(currentPageNum) {
        this.pageNum = currentPageNum
        this.initData()
      },
      // 时间段改变
      durationChange() {
        this.initData()
      },
      // 选择的文件类型改变
      changeFileType (e) {
        this.initData()
      },
      //选择医院
      changeHospital(){
        this.initData()
      },
      // 通过链接下载文件
      // downloadWithUrl (url, fileName) {
      //   // 创建一个 a 标签
      //   let alink = document.createElement('a')
      //   // 但是不用显示
      //   alink.style.display = 'none'
      //   alink.href = url
      //   alink.download = fileName
      //   alink.target = '_parent'
      //   document.body.appendChild(alink)
      //   // 点击下载
      //   alink.click()
      //
      //   // 下载完后移除元素
      //   document.body.removeChild(alink)
      // },
      // downloadFile (url, fileName) {
      //   const iframe = document.createElement("iframe");
      //   iframe.style.display = "none"; //防止影响页面
      //   iframe.style.height = 0; //防止影响页面
      //   iframe.src = url;
      //   document.body.appendChild(iframe); //这一行必须，iframe挂在到dom树上才会发请求
      //   setTimeout(()=> {
      //     iframe.remove();
      //   },1000);
      // },
      async downloadFile (url, fileName) {
        fetch(url).then(res => res.blob().then(blob => {
          let a = document.createElement('a')
          let url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = fileName
          a.click()
          window.URL.revokeObjectURL
        }))
        await this.sleep(1000)
      },
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
      },
      // 点击下载全部选择文件
      async downloadSelectFile () {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          let files = this.multipleSelection[i].image_url.split(',')
          console.log(files)
          for (let j = 0; j < files.length; j++) {
            if (files[j] != '') {
              let str = files[j]
                  str = str.substr(0,4)+'s'+str.substr(4)
              if(files[j].indexOf(this.value) != -1) {
                let sex = this.multipleSelection[i].sex == 1 ? '男' : '女'
                if(files[j].search("difficult") == -1){
                await this.downloadFile(str, this.multipleSelection[i].order_sn + '_' + this.multipleSelection[i].name +
                  '-' + this.multipleSelection[i].age  + '_' + sex + '_' + this.multipleSelection[i].phone_num + '_' + j)
                }else{
                  await this.downloadFile(str, this.multipleSelection[i].order_sn + '_' + this.multipleSelection[i].name +
                  '-' + this.multipleSelection[i].age  + '_' + sex + '_' + this.multipleSelection[i].phone_num + '_' + j + '_' + 'difficult')
                }
              }
            }
          }
        }
      },
      exportExcel () {
        let pageSize = this.pageSize
        let pageNum = this.pageNum
        let durationStart = this.duration[0].getTime()
        let durationEnd = this.duration[1].getTime()
        this.axios({
          method: 'GET',
          url: Global.yunyingUrl + '/service-order/order/findOrderToExcelData?durationStart=' + durationStart + '&durationEnd=' +
          durationEnd + '&pageNum=' + pageNum + '&pageSize=' + pageSize + '&hospitalId=' + this.hospitalDaily,
          // url: 'http://localhost' + '/service-order/order/findOrderToExcelData?durationStart=' + durationStart + '&durationEnd=' +
          //   durationEnd + '&pageNum=' + pageNum + '&pageSize=' + pageSize,
          responseType: 'blob'
        }).then(response => {
          let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let url = URL.createObjectURL(blob)
          window.open(url)
          this.$message({
            type: 'success',
            message: '正在下载'
          })
        })
      }
    }
  }
</script>

<style scoped>

.time-picker {
  /*text-align: center;*/
}

.selected-count {
  position: fixed;
  right: 20px;
  bottom: 20px;
  background-color: white;
  color: #409EFF;
  padding: 10px 15px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(174, 238, 182, 0.1);
  z-index: 1000;
}

</style>



// WEBPACK FOOTER //
// src/components/DataDownload.vue